<svg width="23" height="30" viewBox="0 0 23 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="8" y="4.5" width="7" height="1.4" rx="0.7" fill="currentColor"/>
<rect x="1.2" y="0.7" width="20.6" height="28.6" rx="2.8" stroke="currentColor" stroke-width="1.6"/>
</svg>
